const TableActionTypes = {
  DATA_CREATED: "TABLE_DATA_HASH_CREATED",
  SERVER_DATA_RECEIVED: "TABLE_SERVER_DATA_RECEIVED",
  DATA_UPDATED: "TABLE_DATA_HASH_CHANGED",
  ROW_ADDED: "TABLE_ROW_ADDED",
  DATA_MODIFIED: "TABLE_DATA_MODIFIED",
  ROWS_PER_PAGE_CHANGED: "ROWS_PER_PAGE_CHANGED",
};

export default TableActionTypes;
